module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"company":"Company","vacancy":"Vacancy"}}')
  delete Component.options._Ctor
}
